import { users } from "@/api/users/useUsersQuery";
import { translateWithPartnerType } from "@/utils/partnerType";
import { useMantineColorScheme } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Th, Thead } from "./PurchaseOrderTableInRowHead";

interface PurchaseOrderTableHeadProps {
  pageKey: "purchaseOrder" | "order";
}

export const PurchaseOrderTableHead = ({ pageKey }: PurchaseOrderTableHeadProps) => {
  const { t } = useTranslation();
  const { data: userInfo } = useQuery(users.who({}));
  const partnerType = userInfo?.data?.partner?.type;
  const { colorScheme } = useMantineColorScheme();

  return (
    <Thead theme={{ colorScheme }}>
      <Th></Th>
      <Th>{translateWithPartnerType(t, `${pageKey}.id`, partnerType)}</Th>
      <Th>{translateWithPartnerType(t, `${pageKey}.status`, partnerType)}</Th>
      <Th>{translateWithPartnerType(t, `${pageKey}.category`, partnerType)}</Th>
      <Th>{translateWithPartnerType(t, `${pageKey}.code`, partnerType)}</Th>
      <Th>{translateWithPartnerType(t, `${pageKey}.name`, partnerType)}</Th>
      <Th>{t("partner.name")}</Th>
      <Th>{translateWithPartnerType(t, `${pageKey}.toLocationName`, partnerType)}</Th>
      <Th>{t("order.manager")}</Th>
      <Th>{translateWithPartnerType(t, `${pageKey}.numberOfPurchaseOrderItems`, partnerType)}</Th>
      <Th>{translateWithPartnerType(t, `${pageKey}.orderDate`, partnerType)}</Th>
      <Th>{t("order.createdAt")}</Th>
      <Th>{t("order.deliveryDate")}</Th>
      <Th>{t("common.action")}</Th>
    </Thead>
  );
};
